module.exports = __webpack_public_path__ + "img/17_35.174d9d72.png";